/**
 * Phase 6 — Storage Safe Mode (Stammdaten read-only, Verkauf mit allowInSafeMode).
 */

export const STORAGE_SAFE_MODE_CHANGED = 'storageSafeModeChanged';

/** @type {boolean} */
let safeMode = false;

/** @type {string|null} */
let safeModeReason = null;

/** Maintenance erlaubt kurzzeitig Writes (Cleanup, Recovery). */
let maintenanceWriteBypass = false;

function notifySafeModeChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(STORAGE_SAFE_MODE_CHANGED));
  }
}

export function isStorageSafeMode() {
  return safeMode;
}

export function getStorageSafeModeReason() {
  return safeModeReason;
}

export function enableStorageSafeMode(reason = 'recovery_failure') {
  const already = safeMode && safeModeReason === reason;
  safeMode = true;
  safeModeReason = reason;
  if (!already) {
    notifySafeModeChanged();
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Storage Safe Mode] enabled:', reason);
    }
  }
}

export function disableStorageSafeMode() {
  safeMode = false;
  safeModeReason = null;
  notifySafeModeChanged();
}

export function setMaintenanceWriteBypass(enabled) {
  maintenanceWriteBypass = !!enabled;
}

/**
 * @param {{ allowInSafeMode?: boolean }} [options]
 */
export function assertBusinessPayloadWriteAllowed(options = {}) {
  if (options.allowInSafeMode || maintenanceWriteBypass || !safeMode) return;
  const err = new Error(
    'Storage safe mode: écriture bloquée (données de base en lecture seule). Les ventes restent autorisées.'
  );
  err.code = 'STORAGE_SAFE_MODE';
  throw err;
}
